<div class="app-content content">
    <div class="content-wrapper">
        <div class="content-header row mb-1">
            <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
        </div>
        <ng-container mCardHeaderTitle>
            <ng-template #modalContent let-close="close">


                <form #f1="ngForm" (keydown.enter)="$event.preventDefault()" (keydown.shift.enter)="$event.preventDefault()" (ngSubmit)="SaveCustomer(f1.form.valid)">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ model.action }}</h5>
                        <button type="button" class="close" (click)="close()">
              <span aria-hidden="true">&times;</span>
            </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-body">
                            <div class="form-group">
                                <input type="hidden" id="idCustomer" name="idCustomer" [(ngModel)]="model.idCustomer" value=0 #idCustomer="ngModel">
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="firstName">Full Name *</label>
                                        <input type="text" id="customerFirstName" class="form-control border-primary" placeholder="Full Name" [(ngModel)]="model.customerFirstName" name="customerFirstName" #customerFirstName="ngModel" required>
                                        <small class="form-text text-muted danger" *ngIf="!customerFirstName.valid && f1.submitted">First
                      Name is required.</small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">GST No </label>
                                        <input type="text" id="customerGSTNO" class="form-control border-primary" placeholder="GST No" [(ngModel)]="model.customerGSTNO" name="customerGSTNO" #customerGSTNO="ngModel">

                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">Email Id</label>
                                        <input type="email" id="customerEmail" class="form-control border-primary" placeholder="Email Id" [(ngModel)]="model.customerEmail" name="customerEmail" #customerEmail="ngModel">

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">Contact No </label>
                                        <input type="text" id="customerContact" class="form-control border-primary" placeholder="Contact No" [(ngModel)]="model.customerContact" name="customerContact" #customerContact="ngModel">
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">Address </label>
                                        <input type="text" id="customerAddress" class="form-control border-primary" placeholder="Address" [(ngModel)]="model.customerAddress" name="customerAddress" #customerAddress="ngModel">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-outline-secondary">Save</button>
                    </div>
                </form>
            </ng-template>
        </ng-container>
        <div class="content-body">
            <!-- <ngx-spinner bdColor = "rgba(0,0,0,0.5)" size = "medium" color = "#fff" type = "line-spin-fade" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner> -->
            <app-custom-loader-c></app-custom-loader-c>
            <section id="drag-area">
                <div class="row">
                    <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
                        <m-card [options]="options" (reloadFunction)="reloadProjectInfo($event)">
                            <ng-container mCardBody>
                                <form #f="ngForm" (keydown.enter)="$event.stopPropagation()" (ngSubmit)="$event.stopPropagation()">
                                    <div class="form-body">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="firstName">Select Customer *</label>
                                                    <ng-select [items]="customerarray" style=" border: 1px solid #666ee8" [searchable]="true" bindLabel="customerFullName" id="selectcustomer" placeholder="Select Customer" [(ngModel)]="model.selectcustomer" [disabled]="booleanvalue" [virtualScroll]="true"
                                                        (change)="bindformcustomer(model.selectcustomer)" name="selectcustomer" #selectcustomer="ngModel" required>
                                                    </ng-select>
                                                    <small class="form-text text-muted danger" *ngIf="!selectcustomer.valid && f.submitted">Please
                            select Customer .</small>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <a (keydown.enter)="$event.preventDefault()" (click)="addcustomer()" class="btn btn-primary btn-sm gap_contact" style="margin-top: 6%;color:aliceblue">
                                                        <i class="d-md-none d-block feather ft-plus white"></i><span class="d-md-block d-none">Add
                              Customer</span></a>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="firstName"></label>
                                                </div>
                                            </div>
                                        </div>
                                        <ng-container *ngIf="showcustomer">
                                            <div class="form-actions text-right">
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="div-custom-header" for="PatientInformation">Customer Information </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="FirstName">Full Name :</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label for="FirstName">{{customermodel.customerFirstName}}</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="DOB">GST No:</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label for="DOB">{{customermodel.customerGSTNO}}</label>
                                                    </div>
                                                </div>


                                            </div>
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="EmailId"><b>Email Id :</b></label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label for="EmailId">{{customermodel.customerEmail}}</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="Gender">Contact No:</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label for="Gender">{{customermodel.customerContact}}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="ContactNo">Address:</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <p>{{customermodel.customerAddress}}</p>
                                                    </div>
                                                </div>

                                            </div>


                                            <div class="form-actions text-right">
                                            </div>
                                            <ng-container>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="div-custom-header" for="Product"><b>Bill</b></label>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <br><br>
                                                            <div class="checkboxsas">
                                                                <label>
                                  <input type="checkbox" name="isIgstBill" [(ngModel)]="model.isIgstBill">
                                  IGST Bill
                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group">
                                                            <label for="billdate">Date *</label><input type="date" class="form-control border-primary" [(ngModel)]="model.billDate" name="billDate" #billDate="ngModel" [max]="maxdate" required />
                                                            <small class="form-text text-muted danger" *ngIf="!billDate.valid && f.submitted">Please
                                Bill Date .</small>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label for="remark">Remark </label>
                                                            <input type="text" class="form-control border-primary" [(ngModel)]="model.remark" name="remark" #remark="ngModel" placeholder="Enter remark" />

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-actions text-right">
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="div-custom-header" for="Product"><b>Product</b></label>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="row">
                                                        <div class="col-md-2">
                                                            <div class="form-group">
                                                                <label for="productItemBarCode">Barcode</label>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <label for="productItemDescription">Description *</label>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div class="form-group">
                                                                <label for="ProductItemSerialNo">Serial No </label>


                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div class="form-group">
                                                                <label for="Warranty">Warranty</label>


                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">
                                                                <label for="productItemPrice">Rate</label>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">
                                                                <label for="productItemMRP">MRP</label>

                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                                <div *ngFor="let obj of productItems; let i=index">
                                                    <div *ngIf="obj.operationState !='d'" class="row">
                                                        <div class="col-md-2">
                                                            <div class="form-group">

                                                                <input type="text" class="form-control border-primary" (keypress)="updateOperationStateForBillItem(i);" [(ngModel)]="productItems[i].productItemBarCode" id="productItemBarCode{{i}}" (keydown)="$event.keyCode == 13 ? $event.preventDefault() : null" (keyup.enter)="onScan(i)"
                                                                    placeholder="Barcode" name="productItemBarCode{{i}}" #productItemBarCode>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="form-group">

                                                                <input type="text" #productItemDescription class="form-control border-primary" [placeHolder]="placeholder" (keypress)="updateOperationStateForBillItem(i);" [(ngModel)]="productItems[i].productItemDescription" placeholder="Description" name="productItemDescription{{i}}"
                                                                    [notFoundTemplate]="notFoundTemplate" required>




                                                                <small class="form-text text-muted danger" *ngIf="(productItems[i].productItemDescription=='' || productItems[i].productItemDescription==undefined) && f.submitted">Please
                                  enter
                                  Item .</small>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div class="form-group">

                                                                <input type="text" class="form-control border-primary" [(ngModel)]="productItems[i].productItemSerialNo" (keypress)="updateOperationStateForBillItem(i);" placeholder="Serial No " name="productItemSerialNo{{i}}" #productDescription="ngModel">

                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">

                                                                <select class="form-control border-primary" [(ngModel)]="productItems[i].productWarrantyInYear" name="productWarrantyInYear{{i}}" placeholder="productWarrantyInYear" #productWarrantyInYear="ngModel" (change)="updateOperationStateForBillItem(i);">
                                  <option value="">Select Year</option>
                                  <option value="0">0</option>
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                  <option value="6">6</option>
                                  <option value="7">7</option>
                                  <option value="8">8</option>
                                  <option value="9">9</option>
                                  <option value="10">10</option>


                                </select>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">
                                                                <select class="form-control border-primary" [(ngModel)]="productItems[i].productWarrantyInMonth" name="productWarrantyInMonth{{i}}" placeholder="productWarrantyInMonth" #productWarrantyInMonth="ngModel" (change)="updateOperationStateForBillItem(i);">
                                  <option value="">Select Month</option>
                                  <option value="0">0</option>
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                  <option value="6">6</option>
                                  <option value="7">7</option>
                                  <option value="8">8</option>
                                  <option value="9">9</option>
                                  <option value="10">10</option>
                                  <option value="11">11</option>
                                  <option value="12">12</option>
                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">

                                                                <input type="number" class="form-control border-primary" min=1 [(ngModel)]="productItems[i].productItemPrice" placeholder="Rate" name="productItemPrice{{i}}" #productItemPrice="ngModel" (focusout)="CalculatTotalPaidAmount()" (change)="CalculateDiscount($event)"
                                                                    
                                                                    (keyup) = "updateOperationStateForBillItem(i); CalculatTotalPaidAmount()"
                                                                    required>
                                                                <small class="form-text text-muted danger" *ngIf="productItems[i].productItemPurchesPrice>=productItems[i].productItemPrice ">Price
                                  is to less .</small>

                                                                <small class="form-text text-muted danger" *ngIf="productItems[i].productItemPrice>=productItems[i].productItemMRP && productItems[i].productItemMRP!=0 && productItems[i].productItemMRP!=undefined && productItems[i].productItemMRP!=null">Price
                                  is
                                  greater than MRP.</small>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">

                                                                <input type="number" class="form-control border-primary" [(ngModel)]="productItems[i].productItemMRP" placeholder="MRP" name="productItemMRP{{i}}" (change)="CalculateDiscount($event)" #productItemMRP="ngModel" (keypress)="updateOperationStateForBillItem(i);">


                                                            </div>
                                                        </div>

                                                        <div class="col-md-1">
                                                            <div class="zommin form-group">

                                                                <a class="danger delete " title="Delete">
                                                                    <i (click)="RemoveForm(i)" style="padding: 10%; font-size: 1.9rem;" class="la la-trash-o"></i>
                                                                </a>
                                                            </div>



                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-2">

                                                    </div>
                                                    <div class="col-md-3">

                                                    </div>
                                                    <div class="col-md-2">

                                                    </div>
                                                    <div class="col-md-2">

                                                    </div>
                                                    <div class="col-md-2">

                                                    </div>

                                                    <div class="col-md-1">
                                                        <div class="zommin form-group">
                                                            <a title="Add">
                                                                <img (click)="AddForm()" style="    padding-left: 10%;
                                  margin-top: -44%;" src="../../../../../assets/images/icons/plusicon.png">
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-actions " style="margin-top: 40px;">
                                                    <!-- 
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="totalMrp">Total MRP </label>
                                <input type="text" class="form-control border-primary" [(ngModel)]="model.totalMrp"
                                  name="totalMrp" placeholder="Total MRP" #totalMrp="ngModel" readonly />

                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="totalAmountIncGST">Total Discounted Price </label>
                                <input type="text" class="form-control border-primary"
                                  [(ngModel)]="model.totalAmountIncGST" name="totalAmountIncGST"
                                  placeholder="Discounted Price" #totalMrp="ngModel" readonly />

                              </div>
                            </div>
                          </div> -->

                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label class="div-custom-header" for="Payments"><b>Payment</b></label>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div *ngFor="let obj1 of paymentsarray; let i=index">

                                                        <div *ngIf="obj1.operationState !='d'">
                                                            <div class="form-group">
                                                                <div class="row">

                                                                    <div class="col-md-3">
                                                                        <div class="form-group">
                                                                            <label for="payment-gateway">Payment Method</label>
                                                                            <select class="form-control border-primary" [(ngModel)]="paymentsarray[i].payMode" name="payMode{{i}}" placeholder="payMode" #payMode="ngModel" (change)="chnagePayMod(i); updateOperationState(i);">
                                        <option value="">Select payment Method</option>
                                        <option value="By Cash">By Cash</option>
                                        <option value="By Cheque">By Cheque</option>
                                        <option value="By RTGS/NEFT">By RTGS/NEFT</option>
                                        <option value="By UPI">By UPI</option>
                                      </select>

                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-2">
                                                                        <div class="form-group">
                                                                            <label for="paidAmount">Amount </label>
                                                                            <input type="number" class="form-control border-primary" [(ngModel)]="paymentsarray[i].paidAmount" (keypress)="updateOperationState(i);" (focusout)="CalculatTotalPaidAmount();updateOperationState(i);" name="paidAmount{{i}}" placeholder="PaidAmount" (change)="CalculatTotalPaidAmount()"
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-3">
                                                                        <div class="form-group">
                                                                            <label for="paymentDate">Payment Date</label>
                                                                            <input class="form-control border-primary" [(ngModel)]="paymentsarray[i].paymentDate" [max]="maxdate" (change)="updateOperationState(i);" name="updateOperationState{{i}}" placeholder="paymentDate" type="date" required />
                                                                            <small class="form-text text-muted danger" *ngIf="paymentsarray[i].paymentDate=='' || paymentsarray[i].paymentDate==undefined">Please
                                        select payment date
                                        .</small>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-3" *ngIf="(paymentsarray[i].payMode=='By RTGS/NEFT')||(paymentsarray[i].payMode=='By UPI')">
                                                                        <div class="form-group">
                                                                            <label for="transactionId">Transaction Id</label>
                                                                            <input type="text" class="form-control border-primary" [(ngModel)]="paymentsarray[i].transactionId" (keypress)="updateOperationState(i);" name="transactionId{{i}}" placeholder="Transaction Id" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-1">
                                                                        <div class="zommin form-group">
                                                                            <a class="danger delete " title="Delete">
                                                                                <i (click)="RemoveFormPaymentsarray(i)" style="padding-top: 31%;
                                        font-size: 1.9rem;" class="la la-trash-o"></i>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div *ngIf="paymentsarray[i].payMode=='By Cheque'">
                                                                    <div class="row">
                                                                        <div class="col-md-5">
                                                                            <div class="form-group">
                                                                                <label for="bankName">Bank Name</label>
                                                                                <input type="text" class="form-control border-primary" [(ngModel)]="paymentsarray[i].bankName" (keypress)="chnagePayMod(i);" (keypress)="updateOperationState(i);" name="bankName{{i}}" placeholder="Bank Name" />

                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-5">
                                                                            <div class="form-group">
                                                                                <label for="branchName">Branch Name</label>
                                                                                <input type="text" class="form-control border-primary" [(ngModel)]="paymentsarray[i].branchName" (keypress)="chnagePayMod(i);" (keypress)="updateOperationState(i);" name="branchName{{i}}" placeholder="Branch Name" />
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-5">
                                                                            <div class="form-group">
                                                                                <label for="chequeNumber">Cheque Number</label>
                                                                                <input type="text" class="form-control border-primary" [(ngModel)]="paymentsarray[i].chequeNumber" (keypress)="chnagePayMod(i);" (keypress)="updateOperationState(i);" name="chequeNumber{{i}}" placeholder="Cheque Number" />

                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-5  ">
                                                                            <div class="form-group">
                                                                                <label for="ifscCode">IFSCCode</label>
                                                                                <input type="text" class="form-control border-primary" [(ngModel)]="paymentsarray[i].ifscCode" name="ifscCode{{i}}" (keypress)="chnagePayMod(i);" (keypress)="updateOperationState(i);" placeholder="IFSCCode" />
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                                <div>

                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                        </div>
                                                        <div class="col-md-2">

                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="form-group">

                                                            </div>
                                                        </div>
                                                        <div class="zommin col-md-1">
                                                            <a title="Add">

                                                                <img (click)="AddFormPaymentsarray()" style="    padding-left: 10%;
                                margin-top: -44%;" src="../../../../../assets/images/icons/plusicon.png">

                                                            </a>

                                                        </div>
                                                    </div>
                                                    <div class="form-actions text-right">
                                                    </div>





                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <label class="div-custom-label" for="totalAmountIncGST">Total Price: </label>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <label>{{currency}}{{model.totalAmountIncGST}} </label>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <label class="div-custom-label" for="totalpaidAmount">Total Paid Amount</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <label for="totalpaidAmount">{{currency}}{{model.totalpaidAmount}}</label>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <label class="div-custom-label" for="discount">Discount </label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <label for="discount">{{model.discount}} %</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <label class="div-custom-label" for="totalAmountIncGST">Balance Amount</label>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <label>{{currency}}{{model.balanceAmount}} </label>

                                                            </div>
                                                        </div>



                                                    </div>


                                                </div>
                                                <div class="form-actions text-right">

                                                    <button type="button" (click)="cancel()" class="btn btn-warning mr-1">
                            <i class="feather ft-x"></i> Cancel
                          </button>
                                                    <button type="submit" (keydown.enter)="$event.stopPropagation()" (click)="saveBill(f.form.valid)" class="btn btn-primary">
                            <i class="la la-check"></i> Save
                          </button>

                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </form>
                            </ng-container>
                        </m-card>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>